import request from '@/utils/request'

// 获取快递信息
export function kuaidi(params) {
    return request({
        url: '/handle/kuaidi/order_list',
        method: 'POST',
        data: params
    })
}
// 获取个人信息
export function ziliao(params) {
    return request({
        url: '/handle/index/ziliao',
        method: 'POST',
        data: params
    })
}
// 退出登陆
export function logou(params) {
    return request({
        url: '/handle/index/logout',
        method: 'POST',
        data: params
    })
}
// 获取我的保函列表
export function bhlist(params) {
    return request({
        url: '/handle/baohan/bhlist',
        method: 'POST',
        data: params
    })
}
// 获取保函详情
export function bh_detail(params) {
    return request({
        url: '/handle/index/detail',
        method: 'POST',
        data: params
    })
}
// 获取发票列表
export function fapiao(params) {
    return request({
        url: '/handle/index/fapiao',
        method: 'POST',
        data: params
    })
}
// 申请发票
export function shenqingkaipiao(params) {
    return request({
        url: '/handle/index/shenqingkaipiao',
        method: 'POST',
        data: params
    })
}
// 修改密码
export function password(params) {
    return request({
        url: '/handle/index/password',
        method: 'POST',
        data: params
    })
}
// 实名认证
export function renzheng_geren(params) {
        return request({
            url: '/handle/index/renzheng_geren',
            method: 'POST',
            data: params
        })
    }
    // 审核
export function addresslists(params) {
        return request({
            url: '/handle/address/addresslist',
            method: 'POST',
            data: params
        })
    }

    // 我的地址
export function addresslist(params) {
    return request({
        url: '/handle/address/addresslist',
        method: 'POST',
        data: params
    })
}
export const list = (params) => {

    return request({
      method: "POST",
      data:params,
      url: "/handle/message/messageList",
    });
  };
  export const homepage = (params) => {

    return request({
      method: "POST",
      data:params,
      url: "apply/message/messageDetail",
    });
  };
  export const messageDel = (params) => {

    return request({
      method: "POST",
      data:params,
      url: "/apply/message/messageDel",
    });
  };


// WEBPACK FOOTER //
// ./src/api/system/usercenter.js